import React from 'react';
import PropTypes from 'prop-types';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function ModalComponentSwitcher(props) {
  const {currentKey, children, ...componentProps} = props;
  const currentComponent = React.Children.toArray(children).find(
    child => child.props.name === currentKey
  );
  if (currentComponent) {
    return React.cloneElement(currentComponent, {
      ...componentProps
    });
  }
  return <></>;
}

const propTypes = {
  children: PropTypes.node,
  currentKey: PropTypes.string,
  modalComponentProps: PropTypes.object
};

ModalComponentSwitcher.propTypes = propTypes;
